import script from "./AnimationToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationToolbar.vue?vue&type=script&setup=true&lang=js"

import "./AnimationToolbar.vue?vue&type=style&index=0&id=0c71bbe2&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c71bbe2"]])

export default __exports__